import useFirebase from "hooks/useFirebase";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React from "react";

export default function FirebasePushNotificationComponent() {
  useFirebase();
  return null;
}
